<template>
    <div class="basic_wrap">
        <colorHeader :radius="false" :kefu="true" :title="data.title"/>
        <div class="ctn">
            <!-- <vue-editor v-model="data.content" style="display: none"/> -->
            <div class="contract_box" v-html="data.content"></div>
        </div>
    </div>
</template>

<script>

    import Fetch from "../../utils/fetch";
	import bsHeader from '../../components/bsHeader.vue'

    export default {
        name: "aritcle",
        components: {bsHeader},
        data() {
            return {
                data: {},
            };
        },
        created() {
            this.$parent.footer('user',false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/article_detail', {
                    id: this.$router.history.current.params.code
                }).then(res => {
                    this.data = res.data;
                })
            },
        }
    };
</script>

<style lang="less" scoped>
    .basic_wrap {
        overflow-x: hidden;
        overflow-y: auto;
        background: #f5f5f5;
    }

    .basic_wrap .ctn {
        width: 100%;
        background: #fff;
        padding: 8px;
        margin: 0 auto;
    }
	.contract_box{
		line-height: 20px;
	}

    .basic_wrap .ctn .title {
        font-size: 12px;
        color: #333;
        font-weight: bold;
        line-height: 1.7;
    }

    .basic_wrap .ctn .info {
        font-size: 12px;
        color: #333;
        line-height: 1.7;
    }
</style>